(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(arr);
}


function $09c9f293d010c0e1$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
}


function $227c6742e0ff6f82$export$1b5e630bc3aea29f(arr) {
    return (0, $c50969dc1df61e8b$export$7e0947b5ad3404e2)(arr) || (0, $09c9f293d010c0e1$export$1eb58a6e75231000)(arr) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr) || (0, $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$2996f80ef42b8419)(this, Game);
        this.initialState = initialState;
        this.board = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.boardScore = 0;
        this.currentStatus = "idle";
        this.isAbleToMove = true;
        this.isGameActive = false;
        this.isGameWon = false;
        this.isGameLost = false;
    }
    (0, $4fc75ccb937ab1df$export$d60067ff2358eee8)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.isGameActive) this.moveTo("left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.isGameActive) this.moveTo("right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.isGameActive) this.moveTo("up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.isGameActive) this.moveTo("down");
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.boardScore;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                switch(true){
                    case this.isGameWon:
                        this.currentStatus = "win";
                        break;
                    case this.isGameLost:
                        this.currentStatus = "lose";
                        break;
                    case this.isGameActive:
                        this.currentStatus = "playing";
                        break;
                    default:
                        this.currentStatus = "idle";
                        break;
                }
                return this.currentStatus;
            }
        },
        {
            key: "start",
            value: function start() {
                this.isGameActive = true;
                this.placeNewCell();
                this.placeNewCell();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.boardScore = 0;
                this.isGameActive = true;
                this.isGameWon = false;
                this.isGameLost = false;
                this.placeNewCell();
                this.placeNewCell();
            }
        },
        {
            key: "placeNewCell",
            value: function placeNewCell() {
                var randomRow, randomColumn;
                do {
                    randomRow = Math.floor(Math.random() * 4);
                    randomColumn = Math.floor(Math.random() * 4);
                }while (this.board[randomRow][randomColumn] !== 0);
                this.board[randomRow][randomColumn] = this.createCell();
            }
        },
        {
            key: "createCell",
            value: function createCell() {
                var randomValue = Math.random();
                return randomValue < 0.1 ? 4 : 2;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(direction) {
                var _this = this;
                if (!this.isGameActive) return;
                var numColumns = this.board[0].length;
                var currentTable = JSON.parse(JSON.stringify(this.board));
                var addScore = 0;
                var transpose = function(table) {
                    return table[0].map(function(_, colIndex) {
                        return table.map(function(row) {
                            return row[colIndex];
                        });
                    });
                };
                var reverseRow = function(table) {
                    return table.map(function(row) {
                        return row.slice().reverse();
                    });
                };
                var moveTable = function(table) {
                    var newTable = table.map(function(row) {
                        var newRow = row.filter(function(num) {
                            return num !== 0;
                        });
                        var zerosToAdd = numColumns - newRow.length;
                        newRow = (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(Array(zerosToAdd).fill(0)).concat((0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(newRow));
                        for(var i = newRow.length; i >= 0; i--)if (newRow[i - 1] === newRow[i]) {
                            newRow[i - 1] *= 2;
                            newRow[i] = 0;
                            addScore += newRow[i - 1];
                            i--;
                        }
                        newRow = newRow.filter(function(num) {
                            return num !== 0;
                        });
                        var zerosToAddEnd = numColumns - newRow.length;
                        newRow = (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(Array(zerosToAddEnd).fill(0)).concat((0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(newRow));
                        return newRow;
                    });
                    return newTable;
                };
                var isGameOver = function() {
                    var GAME_FIELD = 4;
                    for(var i = 0; i < GAME_FIELD; i++)for(var j = 0; j < GAME_FIELD; j++){
                        if (_this.board[i][j] === 0) return false;
                    }
                    for(var i1 = 0; i1 < GAME_FIELD; i1++)for(var j1 = 0; j1 < GAME_FIELD; j1++){
                        if (j1 < GAME_FIELD - 1 && _this.board[i1][j1] === _this.board[i1][j1 + 1]) return false;
                        if (i1 < GAME_FIELD - 1 && _this.board[i1][j1] === _this.board[i1 + 1][j1]) return false;
                    }
                    _this.isGameActive = false;
                    _this.isGameLost = true;
                    return true;
                };
                var makeMove = function(moveToSide) {
                    if (JSON.stringify(moveToSide) === JSON.stringify(currentTable)) return;
                    _this.board = moveToSide;
                    currentTable = moveToSide;
                    if (_this.board.flat().includes(2048)) {
                        _this.isGameActive = false;
                        _this.isGameWon = true;
                        _this.getStatus();
                        return;
                    }
                    _this.placeNewCell();
                    if (isGameOver()) _this.isAbleToMove = false;
                };
                switch(direction){
                    case "up":
                        var moveUp = transpose(reverseRow(moveTable(reverseRow(transpose(currentTable)))));
                        makeMove(moveUp);
                        this.boardScore += addScore;
                        break;
                    case "down":
                        var moveDown = transpose(moveTable(transpose(currentTable)));
                        makeMove(moveDown);
                        this.boardScore += addScore;
                        break;
                    case "right":
                        var moveRight = moveTable(currentTable);
                        makeMove(moveRight);
                        this.boardScore += addScore;
                        break;
                    case "left":
                        var moveLeft = reverseRow(moveTable(reverseRow(currentTable)));
                        makeMove(moveLeft);
                        this.boardScore += addScore;
                        break;
                }
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$container = document.querySelector(".container");
var $197cd56b15c33885$var$button = $197cd56b15c33885$var$container.querySelector(".button");
var $197cd56b15c33885$var$messageStart = $197cd56b15c33885$var$container.querySelector(".message-start");
var $197cd56b15c33885$var$messageLose = $197cd56b15c33885$var$container.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = $197cd56b15c33885$var$container.querySelector(".message-win");
var $197cd56b15c33885$var$scoreInfo = $197cd56b15c33885$var$container.querySelector(".game-score");
$197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$button.textContent === "Start") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$button.textContent = "Restart";
        $197cd56b15c33885$var$button.classList.add("restart");
        $197cd56b15c33885$var$button.classList.remove("start");
    } else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$updateUI();
});
document.addEventListener("keydown", function(keyboard) {
    switch(keyboard.key){
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        default:
            break;
    }
    $197cd56b15c33885$var$updateUI();
});
function $197cd56b15c33885$var$updateUI() {
    var gameState = $197cd56b15c33885$var$game.getState().flat();
    var fieldCells = $197cd56b15c33885$var$container.querySelectorAll(".field-cell");
    fieldCells.forEach(function(fieldCell, index) {
        var classList = fieldCell.classList;
        var classArray = classList;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = classArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var className = _step.value;
                if (className !== "field-cell") {
                    classList.remove(className);
                    fieldCell.textContent = "";
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (gameState[index] !== 0) {
            fieldCell.classList.add("field-cell--".concat(gameState[index]));
            fieldCell.textContent = gameState[index];
        }
    });
    $197cd56b15c33885$var$scoreInfo.textContent = $197cd56b15c33885$var$game.getScore();
    if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    else if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
}

})();
//# sourceMappingURL=index.f248da40.js.map
